import {PayloadAction, createSlice} from "@reduxjs/toolkit";
import {PlatformConfig, LocalType} from "app/types/common";
import {RootState} from "app/store";

interface ConfigProps {
    platformConfig?: PlatformConfig;
    locale: string;
}

const initialState: ConfigProps = {
    platformConfig: undefined,
    locale: LocalType.En,
};

// ==============================|| SLICE - SNACKBAR ||============================== //

const config = createSlice({
    name: "config",
    initialState,
    reducers: {
        setPlatformConfig(state, action: PayloadAction<PlatformConfig>) {
            state.platformConfig = action.payload;
        },
        setLocale(state, action: PayloadAction<string>) {
            state.locale = action.payload;
            localStorage.setItem("locale", action.payload);
        },
    },
});

export const language = (state: RootState) => state.config.locale;

export default config.reducer;

export const {setPlatformConfig, setLocale} = config.actions;
